<template>
    <div slot="title">
        <h1>{{ $route.params.slug | title('-') }}</h1>
    </div>
</template>

<script>
export default {
    name: 'ht-company-sidebar'
}
</script>